<template>
	<div class="field-management-container">
		<!-- 顶部标签栏 -->
		<div class="tabs-header">
			<!-- <el-tabs v-model="active" @tab-click="handleTabClick">
        <el-tab-pane label="西药药品档案字段" name="1"></el-tab-pane>
        <el-tab-pane label="中药药品档案字段" name="2"></el-tab-pane>
      </el-tabs> -->
		</div>

		<!-- 搜索和操作区域 -->
		<div class="search-operation-bar">
			<!-- <el-select v-model="selectedFieldType" placeholder="请选择字段类型" clearable class="type-select"
				@change="handleTypeChange">
				<el-option v-for="item in fieldTypeOptions" :key="item.value" :label="item.label"
					:value="item.value"></el-option>
			</el-select> -->

			<el-input v-model="searchKeyword" placeholder="搜索字段名称、别名或描述" size="mini" prefix-icon="el-icon-Ssearch"
				class="search-input" clearable @clear="handleSearch" @keyup.enter.native="handleSearch"></el-input>
		</div>

		<!-- 字段表格 - 使用外层容器包裹 -->
		<div class="table-scroll-container">
			<div class="table-container">
				<el-table :data="tableData" stripe style="width: 100%" height="calc(45vh)" v-loading="loading"
					:scroll="{ x: 'max-content' }">
					<el-table-column prop="id" label="字段ID" width="80" align="center" fixed="left">
					</el-table-column>

					<el-table-column prop="fieldName" label="字段名称" width="120" show-overflow-tooltip>
						<template slot-scope="scope">
							<el-input v-model="scope.row.fieldName" size="mini" disabled></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="isShow" label="是否显示" width="100" align="center">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.isShow" :active-value="1" :inactive-value="0"
								active-color="#13ce66" inactive-color="#ff4949" :disabled="getSwitchDisabled(scope.row)"
								@change="handleSwitchChange(scope.row)">
							</el-switch>
						</template>
					</el-table-column>

					<el-table-column prop="fieldExample" label="字段示例" width="120" show-overflow-tooltip>
						<template slot-scope="scope">
							<span style="font-size: 12px;">{{ scope.row.fieldExample }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="sortNum" label="展示顺序" width="80" disabled>
						<template slot-scope="scope">
							<el-input v-model="scope.row.sortNum" size="mini" @change="handleSortNumChange(scope.row)" />
								
						</template>
					</el-table-column>

					<el-table-column prop="isMustChoose" label="必选" width="80" disabled>
						<template slot-scope="scope">
							<el-select v-model="scope.row.isMustChoose" size="mini"
								@change="handleMustChooseChange(scope.row)">
								<el-option label="否" value="0"></el-option>
								<el-option label="是" value="1"></el-option>
							</el-select>
						</template>
					</el-table-column>

					<el-table-column prop="isMustFill" label="必填" width="80" disabled>
						<template slot-scope="scope">
							<el-select v-model="scope.row.isMustFill" size="mini"
								@change="handleMustFillChange(scope.row)">
								<el-option label="否" value="0"></el-option>
								<el-option label="是" value="1"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="fieldType" label="字段类型" width="120">
						<template slot-scope="scope">
							<el-select v-model="scope.row.fieldType" placeholder="请选择" size="mini" disabled>
								<el-option label="日期" value="date"></el-option>
								<el-option label="数字" value="int"></el-option>
								<el-option label="文本" value="text"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="fieldDesc" label="字段描述" width="288" show-overflow-tooltip
						class-name="field-desc-cell">
						<template slot-scope="scope">
							<el-input v-model="scope.row.fieldDesc" size="mini" placeholder="(空)" disabled></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="mini" disabled>编辑</el-button>
							<el-button type="text" size="mini" disabled>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 分页 -->
		<div class="pagination-container">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[8, 20, 50, 100]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalSize"></el-pagination>
		</div>

		<!-- 新增字段模态框 -->
		<el-dialog title="新增字段" :visible.sync="addDialogVisible" width="1200px" :close-on-click-modal="false"
			:before-close="handleAddDialogClose" class="field-add-dialog">
			<div class="dialog-content">
				<!-- 三栏布局 -->
				<div class="dialog-columns">
					<!-- 左侧：选择药品类型 -->
					<div class="left-column">
						<div class="section-header">
							<span class="section-number">1.</span>
							<span class="section-title">选择药品类型</span>
						</div>
						<div class="drug-type-list">
							<div v-for="drugType in drugTypeOptions" :key="drugType.value" class="drug-type-item"
								:class="{ active: selectedDrugType === drugType.value }"
								@click="handleDrugTypeSelect(drugType.value)">
								<el-radio v-model="selectedDrugType" :label="drugType.value" class="drug-type-radio">
									{{ drugType.label }}
								</el-radio>
							</div>
						</div>
					</div>

					<!-- 中间：新增字段名称 -->
					<div class="middle-column">
						<div class="section-header">
							<span class="section-number">2.</span>
							<span class="section-title">新增字段名称</span>
						</div>
						<div class="field-name-section">
							<div class="field-name-input">
								<label class="field-name-label">字段名称：</label>
								<el-input v-model="newField.fieldName" placeholder="请输入字段名称" size="small"
									@input="generateFieldCode" />
							</div>
							<div class="field-code-input">
								<label class="field-code-label">字段编码：</label>
								<el-input v-model="newField.fieldCode" placeholder="自动生成字段编码" size="small" disabled />
							</div>
							<div class="field-desc-input">
								<label class="field-desc-label">字段描述：</label>
								<el-input v-model="newField.fieldDesc" type="textarea" :rows="3" placeholder="请输入字段描述"
									size="small" />
							</div>
						</div>
					</div>

					<!-- 右侧：设置字段信息 -->
					<div class="right-column">
						<div class="section-header">
							<span class="section-number">3.</span>
							<span class="section-title">设置字段信息</span>
						</div>
						<div class="field-info-section">
							<div class="info-item">
								<label class="info-label">字段类型：</label>
								<el-select v-model="newField.fieldType" placeholder="请选择字段类型" size="small"
									@change="handleFieldTypeChange">
									<el-option label="输入框" value="input" />
									<el-option label="下拉框" value="select" />
									<el-option label="复选框" value="checkbox" />
									<el-option label="日期时间" value="datetime" />
									<el-option label="文本域" value="textarea" />
									<el-option label="级联选择器" value="cascader" />
								</el-select>
							</div>

							<div class="info-item">
								<label class="info-label">是否必填：</label>
								<el-switch v-model="newField.isRequired" active-text="是" inactive-text="否" />
							</div>

							<div class="info-item">
								<label class="info-label">是否显示：</label>
								<el-switch v-model="newField.isShow" active-text="是" inactive-text="否" :active-value="1"
									:inactive-value="0" />
							</div>

							<div class="info-item">
								<label class="info-label">排序序号：</label>
								<el-input-number v-model="newField.sortNum" :min="0" :max="999" size="small"
									controls-position="right" />
							</div>

							<!-- 根据字段类型显示不同的配置选项 -->
							<div v-if="newField.fieldType === 'select'" class="field-options">
								<div class="info-item">
									<label class="info-label">选项配置：</label>
									<div class="options-container">
										<div v-for="(option, index) in newField.options" :key="index"
											class="option-item">
											<el-input v-model="option.label" placeholder="选项标签" size="small"
												style="width: 120px; margin-right: 8px;" />
											<el-input v-model="option.value" placeholder="选项值" size="small"
												style="width: 120px; margin-right: 8px;" />
											<el-button type="danger" icon="el-icon-delete" size="mini"
												@click="removeOption(index)" />
										</div>
										<el-button type="primary" icon="el-icon-plus" size="small" @click="addOption">
											添加选项
										</el-button>
									</div>
								</div>
							</div>

							<div v-if="newField.fieldType === 'datetime'" class="date-format">
								<div class="info-item">
									<label class="info-label">日期格式：</label>
									<el-select v-model="newField.dateFormat" placeholder="请选择日期格式" size="small">
										<el-option label="年-月-日" value="yyyy-MM-dd" />
										<el-option label="年-月-日 时:分" value="yyyy-MM-dd HH:mm" />
										<el-option label="年-月-日 时:分:秒" value="yyyy-MM-dd HH:mm:ss" />
									</el-select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleAddDialogClose" size="small">取消</el-button>
				<el-button type="primary" @click="handleAddConfirm" size="small" :disabled="!isAddFormValid">
					确定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// 字段设置相关接口
	import {
		FieldList,
		FieldType,
		updateField,
		addField
	} from "@/api/Outpatient/field.js";

	export default {
		name: 'FieldManagement',
		data() {
			return {
				activeTab: '1', // 默认激活字段管理标签
				searchKeyword: '', // 搜索关键词
				selectedFieldType: '', // 选择的字段类型
				fieldTypeOptions: [], // 字段类型下拉选项
				typeCode: 2, // 1为西药 2为中药
				loading: false, // 表格加载状态
				currentPage: 1, // 当前页码
				pageSize: 8, // 每页显示数量
				
				totalSize: 0, // 总条目数
				tableData: [], // 表格数据
				searchTimer: null, // 搜索防抖定时器

				// 新增字段模态框相关数据
				addDialogVisible: false,
				drugTypeOptions: [{
						label: '西药',
						value: 'western'
					},
					{
						label: '中药',
						value: 'chinese'
					}
				],
				selectedDrugType: '',
				newField: {
					fieldName: '',
					fieldCode: '',
					fieldDesc: '',
					fieldType: 'input',
					isRequired: false,
					isShow: 1,
					sortNum: 0,
					options: [{
						label: '',
						value: ''
					}],
					dateFormat: 'yyyy-MM-dd'
				}
			};
		},
		computed: {
			isAddFormValid() {
				// 表单验证逻辑
				return this.selectedDrugType &&
					this.newField.fieldName &&
					this.newField.fieldCode &&
					this.newField.fieldType;
			}
		},
		mounted() {
			// 组件加载时获取字段类型选项
			this.fetchFieldTypeOptions();
			// 然后调用接口获取数据
			this.fetchTableData();
		},
		methods: {
			// 判断显示开关是否禁用
			getSwitchDisabled(row) {
				try {
					// 获取字段类型
					const fieldType = row.inputBoxType || row.fieldType;

					// 如果是输入框类型(input)
					if (fieldType === 'input') {
						// 检查是否必填字段
						const isMustFill = row.isMustFill === '1' || row.isMustFill === 1 || row.isMustFill === true;
						return isMustFill;
					}

					// 如果是下拉选择框类型(selected)
					if (fieldType === 'selected') {
						// 检查是否必选字段
						const isMustChoose = row.isMustChoose === '是' || row.isMustChoose === '1' || row.isMustChoose ===
							1 || row.MustChoose === true;
						return isMustChoose;
					}

					// 其他类型默认不禁用
					return false;
				} catch (error) {
					console.error('判断显示开关状态出错:', error);
					return false;
				}
			},

			// 获取字段类型下拉选项
			async fetchFieldTypeOptions() {
				try {
					const response = await FieldType();
					if (response.code === 200) {
						// 根据接口返回的数据结构调整，这里假设返回的是数组格式
						this.fieldTypeOptions = response.data.map(item => ({
							label: item.typeName || item.label || '未知类型',
							value: item.typeCode || item.value || ''
						}));
					} else {
						this.$message.error(response.message || '获取字段类型失败');
						// 如果接口失败，设置默认选项
						this.setDefaultFieldTypeOptions();
					}
				} catch (error) {
					console.error('获取字段类型失败:', error);
					this.$message.error('获取字段类型失败，请稍后重试');
					// 如果网络错误，设置默认选项
					this.setDefaultFieldTypeOptions();
				}
			},

			// 设置默认的字段型选项
			setDefaultFieldTypeOptions() {
				this.fieldTypeOptions = [{
						label: '全部类型',
						value: ''
					},
					{
						label: '日期类型',
						value: 'date'
					},
					{
						label: '数字类型',
						value: 'int'
					},
					{
						label: '文本类型',
						value: 'text'
					}
				];
			},

			// 字段类型选择变化事件
			handleTypeChange(value) {
				this.selectedFieldType = value;
				this.currentPage = 1; // 重置到第一页
				this.fetchTableData();
			},

			// 选项卡点击事件
			handleTabClick(tab) {
				this.typeCode = parseInt(tab.name); // 更新typeCode
				this.currentPage = 1; // 重置到第一页
				this.fetchTableData(); // 重新获取数据
			},

			// 搜索处理
			// handleSearch() {
			// 	this.currentPage = 1;
			// 	this.fetchTableData();
			// },

			// 获取表格数据
			// 获取表格数据 - 添加搜索参数
			  async fetchTableData() {
			    this.loading = true;
			    try {
			      const params = {
			        pageNum: this.currentPage,
			        pageSize: this.pageSize,
			        typeCode: this.typeCode,
					fieldName: this.searchKeyword
			      };
			
			      // 添加搜索关键词参数
			      if (this.searchKeyword && this.searchKeyword.trim()) {
			        params.fieldName = this.searchKeyword.trim();
			        console.log('添加搜索关键词参数:', params.fieldName);
			      }
			
			      // 添加字段类型筛选参数
			      if (this.selectedFieldType) {
			        params.fieldType = this.selectedFieldType;
			        console.log('添加字段类型筛选参数:', params.fieldType);
			      }
			
			      console.log('请求参数:', params);
			      const response = await FieldList(params);
			
			      if (response.code === 200) {
			        // 接口返回成功，赋值数据
			        this.tableData = response.data.content || [];
			        console.log('获取数据成功，数据条数:', this.tableData.length);
			
			        // 修复分页问题：根据接口返回的数据结构获取总条数
			        if (response.data.totalSize !== undefined) {
			          this.totalSize = response.data.totalSize;
			        } else if (response.data.totalElements !== undefined) {
			          this.totalSize = response.data.totalElements;
			        } else if (response.data.total !== undefined) {
			          this.totalSize = response.data.total;
			        } else {
			          // 如果没有找到总条数字段，使用数组长度作为总条数
			          this.totalSize = this.tableData.length;
			          console.warn('接口未返回总条数，使用当前数据长度作为总条数');
			        }
			
			        console.log('总条数:', this.totalSize);
			
			        // 确保 isShow 字段是数字类型（0或1）
			        this.tableData.forEach(item => {
			          if (item.isShow !== undefined) {
			            item.isShow = Number(item.isShow);
			          }
			          if (item.isMustFill !== undefined) {
			            item.isMustFill = String(item.isMustFill);
			          }
			        });
			      } else {
			        // 接口返回错误
			        this.$message.error(response.message || '获取数据失败');
			        this.tableData = [];
			        this.totalSize = 0;
			      }
			    } catch (error) {
			      console.error('获取字段列表失败:', error);
			      this.$message.error('网络错误，请稍后重试');
			      this.tableData = [];
			      this.totalSize = 0;
			    } finally {
			      this.loading = false;
			    }
			  },

			// 显示开关状态改变事件
			async handleSwitchChange(row) {
				try {
					const params = {
						id: row.id,
						isMustFill: Number(row.isMustFill) || 0,
						isShow: row.isShow,
						sortNum: Number(row.sortNum) || 0
					};

					const response = await updateField(params);

					if (response.code === 200) {
						this.$message.success(`字段"${row.fieldName}"显示状态已${row.isShow === 1 ? '开启' : '关闭'}`);
						// 更新成功后可以重新获取数据或直接更新本地数据
						// this.fetchTableData(); // 如果需要实时同步，可以重新获取数据
					} else {
						this.$message.error(response.message || '更新失败');
						// 恢复原来的状态
						this.fetchTableData();
					}
				} catch (error) {
					console.error('更新字段显示状态失败:', error);
					this.$message.error('网络错误，请稍后重试');
					// 恢复原来的状态
					this.fetchTableData();
				}
			},

			// 展示顺序改变事件
			async handleSortNumChange(row) {
				await this.updateFieldData(row);
			},

			// 是否必选改变事件
			async handleMustChooseChange(row) {
				await this.updateFieldData(row);
			},

			// 是否必填改变事件
			async handleMustFillChange(row) {
				await this.updateFieldData(row);
			},

			// 更新字段数据的通用方法
			async updateFieldData(row) {
				try {
					const params = {
						id: row.id,
						isMustFill: Number(row.isMustFill) || 0,
						isShow: Number(row.isShow) || 0,
						sortNum: Number(row.sortNum) || 0
					};

					const response = await updateField(params);

					if (response.code === 200) {
						this.$message.success('字段信息更新成功');
					} else {
						this.$message.error(response.message || '更新失败');
						// 恢复原来的状态
						this.fetchTableData();
					}
				} catch (error) {
					console.error('更新字段信息失败:', error);
					this.$message.error('网络错误，请稍后重试');
					// 恢复原来的状态
					this.fetchTableData();
				}
			},

			// 搜索字段按钮点击事件 - 修改为搜索功能
			  handleAddField() {
			    // 修改为搜索功能，而不是打开新增对话框
			    this.handleSearch();
			  },

			// 选择药品类型
			handleDrugTypeSelect(type) {
				this.selectedDrugType = type;
			},

			// 根据字段名称自动生成字段编码
			generateFieldCode() {
				if (this.newField.fieldName) {
					// 简单的拼音转换逻辑，实际项目中可以使用pinyin库
					const pinyinMap = {
						'药品': 'drug',
						'名称': 'name',
						'编码': 'code',
						'规格': 'spec',
						'厂家': 'manufacturer',
						'价格': 'price',
						'库存': 'stock',
						'状态': 'status',
						'创建': 'create',
						'时间': 'time',
						'日期': 'date'
					};

					let code = this.newField.fieldName;
					Object.keys(pinyinMap).forEach(key => {
						code = code.replace(new RegExp(key, 'g'), pinyinMap[key]);
					});

					// 移除特殊字符，转换为驼峰命名
					code = code.replace(/[^a-zA-Z0-9]/g, ' ')
						.split(' ')
						.filter(word => word)
						.map((word, index) => {
							if (index === 0) {
								return word.toLowerCase();
							}
							return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
						})
						.join('');

					this.newField.fieldCode = code;
				}
			},

			// 字段类型变化处理
			handleFieldTypeChange(type) {
				// 根据字段类型初始化默认配置
				if (type === 'select') {
					this.newField.options = [{
						label: '',
						value: ''
					}];
				} else if (type === 'datetime') {
					this.newField.dateFormat = 'yyyy-MM-dd';
				}
			},

			// 添加选项
			addOption() {
				this.newField.options.push({
					label: '',
					value: ''
				});
			},

			// 删除选项
			removeOption(index) {
				if (this.newField.options.length > 1) {
					this.newField.options.splice(index, 1);
				} else {
					this.$message.warning('至少保留一个选项');
				}
			},
			// 搜索处理 - 修改为直接调用fetchTableData
			  handleSearch() {
			    console.log('执行搜索，关键词:', this.searchKeyword, '字段类型:', this.selectedFieldType);
			    this.currentPage = 1;
			    this.fetchTableData();
			  },
			// 关闭新增对话框
			handleAddDialogClose() {
				this.addDialogVisible = false;
				this.resetAddForm();
			},

			// 确认新增字段
			async handleAddConfirm() {
				if (!this.isAddFormValid) {
					this.$message.warning('请填写完整的字段信息');
					return;
				}

				try {
					const fieldData = {
						drugType: this.selectedDrugType,
						fieldName: this.newField.fieldName,
						fieldCode: this.newField.fieldCode,
						fieldDesc: this.newField.fieldDesc,
						fieldType: this.newField.fieldType,
						isRequired: this.newField.isRequired,
						isShow: this.newField.isShow,
						sortNum: this.newField.sortNum,
						options: this.newField.fieldType === 'select' ? this.newField.options : [],
						dateFormat: this.newField.fieldType === 'datetime' ? this.newField.dateFormat : '',
						typeCode: this.typeCode
					};

					const response = await addField(fieldData);

					if (response.code === 200) {
						this.$message.success('字段新增成功');
						this.handleAddDialogClose();
						this.fetchTableData(); // 重新加载数据
					} else {
						this.$message.error(response.message || '新增字段失败');
					}
				} catch (error) {
					console.error('新增字段失败:', error);
					this.$message.error('网络错误，请稍后重试');
				}
			},

			// 重置新增表单
			resetAddForm() {
				this.selectedDrugType = '';
				this.newField = {
					fieldName: '',
					fieldCode: '',
					fieldDesc: '',
					fieldType: 'input',
					isRequired: false,
					isShow: 1,
					sortNum: 0,
					options: [{
						label: '',
						value: ''
					}],
					dateFormat: 'yyyy-MM-dd'
				};
			},

			handleSizeChange(size) {
				this.pageSize = size;
				this.currentPage = 1; // 切换每页大小时重置到第一页
				this.fetchTableData();
			},

			handleCurrentChange(page) {
				this.currentPage = page;
				this.fetchTableData();
			}
		},
		watch: {
			// 监听搜索关键词变化，防抖处理
			searchKeyword(newVal, oldVal) {
				if (newVal !== oldVal) {
					clearTimeout(this.searchTimer);
					this.searchTimer = setTimeout(() => {
						this.handleSearch();
					}, 500);
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.field-management-container {
		height: 60vh;
		display: flex;
		flex-direction: column;
		// padding: 20px;
		box-sizing: border-box;
		overflow: hidden;
		background-color: #f5f7fa;

		.tabs-header {
			background-color: #fff;
			border-radius: 4px 4px 0 0;
			// box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

			/deep/ .el-tabs__header {
				margin: 0;
			}
		}

		.search-operation-bar {
			display: flex;
			align-items: center;
			background-color: #fff;
			margin-top: 1px;
			// box-shadow: 0 1px 2px rgba(0, 0, 0.1);

			.type-select {
				width: 150px;
				margin-right: 15px;
			}

			.search-input {
				width: 300px;
				margin-right: 15px;
			}
		}

		// 表格滚动容器 - 外层包裹
		.table-scroll-container {
			flex: 1;
			margin-top: 1px;
			background-color: #fff;
			box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
			overflow-x: auto;
			overflow-y: hidden;
			position: relative;

			// 自定义滚动条样式
			&::-webkit-scrollbar {
				height: 12px;
			}

			&::-webkit-scrollbar-track {
				background: #f1f1f1;
				border-radius: 6px;
			}

			&::-webkit-scrollbar-thumb {
				background: #c0c4cc;
				border-radius: 6px;
				border: 2px solid #f1f1f1;
			}

			&::-webkit-scrollbar-thumb:hover {
				background: #909399;
			}

			// 表格容器
			.table-container {
				width: max-content;
				min-width: 100%;

				/deep/ .el-table {
					width: max-content !important;
					min-width: 100%;

					.el-table__header-wrapper,
					.el-table__body-wrapper {
						width: max-content !important;
					}

					.el-table__header-wrapper {
						th {
							background-color: #fafafa;
							color: #333;
							font-weight: bold;
							white-space: nowrap;
						}
					}

					.el-table__body-wrapper {

						.el-select,
						.el-input {
							width: 100%;
						}

						.switch {
							margin: 0 auto;

							// 禁用状态的开关样式
							&.is-disabled {
								opacity: 0.6;

								.el-switch__core {
									background-color: #f5f7fa !important;
									border-color: #dcdfe6 !important;
									cursor: not-allowed;

									&:after {
										background-color: #c0c4cc !important;
									}
								}
							}
						}

						// 禁用状态的样式
						.el-select.disabled .el-input__inner,
						.el-input.disabled .el-input__inner {
							background-color: #f5f7fa;
							color: #c0c4cc;
							cursor: not-allowed;
						}
					}
				}
			}
		}

		.pagination-container {
			padding: 15px 20px;
			background-color: #fff;
			margin-top: 1px;
			border-radius: 0 0 4px 4px;
			box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
			display: flex;
			justify-content: left;
		}

		// 新增字段对话框样式
		.field-add-dialog {
			.dialog-content {
				padding: 0 20px;

				.dialog-columns {
					display: flex;
					gap: 20px;
					min-height: 400px;

					.left-column,
					.middle-column,
					.right-column {
						flex: 1;
						border: 1px solid #e4e7ed;
						border-radius: 4px;
						padding: 15px;
						background: #fafafa;
					}

					.section-header {
						display: flex;
						align-items: center;
						margin-bottom: 15px;
						padding-bottom: 10px;
						border-bottom: 1px solid #e4e7ed;

						.section-number {
							font-weight: bold;
							color: #409eff;
							margin-right: 5px;
						}

						.section-title {
							font-weight: bold;
							color: #303133;
						}
					}

					// 左侧药品类型样式
					.left-column {
						.drug-type-list {
							.drug-type-item {
								padding: 12px 16px;
								margin-bottom: 10px;
								border: 1px solid #dcdfe6;
								border-radius: 4px;
								cursor: pointer;
								transition: all 0.3s;
								background: white;

								&:hover {
									border-color: #409eff;
									background: #f0f7ff;
								}

								&.active {
									border-color: #409eff;
									background: #ecf5ff;
								}

								.drug-type-radio {
									width: 100%;

									/deep/ .el-radio__label {
										font-size: 14px;
										font-weight: 500;
									}
								}
							}
						}
					}

					// 中间字段名称样式
					.middle-column {
						.field-name-section {

							.field-name-input,
							.field-code-input,
							.field-desc-input {
								margin-bottom: 15px;

								.field-name-label,
								.field-code-label,
								.field-desc-label {
									display: block;
									margin-bottom: 5px;
									font-size: 12px;
									color: #606266;
									font-weight: 500;
								}

								.el-input,
								.el-textarea {
									width: 100%;
								}
							}
						}
					}

					// 右侧字段信息样式
					.right-column {
						.field-info-section {
							.info-item {
								margin-bottom: 15px;

								.info-label {
									display: block;
									margin-bottom: 5px;
									font-size: 12px;
									color: #606266;
									font-weight: 500;
								}

								.el-select,
								.el-input-number,
								.el-switch {
									width: 100%;
								}

								.options-container {
									.option-item {
										display: flex;
										align-items: center;
										margin-bottom: 8px;

										.el-input {
											margin-right: 8px;
										}
									}
								}
							}
						}
					}
				}
			}

			.dialog-footer {
				text-align: right;
				padding: 10px 20px;
				border-top: 1px solid #e4e7ed;
			}
		}
	}

	// 响应式调整
	@media (max-width: 768px) {
		.field-management-container {
			padding: 10px;

			.search-operation-bar {
				flex-direction: column;
				align-items: flex-start;

				.type-select {
					width: 100%;
					margin-right: 0;
					margin-bottom: 10px;
				}

				.search-input {
					width: 100%;
					margin-right: 0;
					margin-bottom: 10px;
				}
			}

			.table-scroll-container {
				/deep/ .table-container {
					/deep/ .el-table {
						min-width: 1200px;
						/* 移动端设置更小的最小宽度 */
					}
				}
			}
		}
	}

	// 字段描述列的文本溢出处理
	.field-desc-cell {
		.el-input__inner {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	// 确保表格列宽固定
	.fixed-column-width {
		min-width: 120px;
		max-width: 120px;
	}

	// 表格滚动提示
	.table-scroll-hint {
		position: absolute;
		bottom: 5px;
		right: 10px;
		background: rgba(0, 0, 0, 0.6);
		color: white;
		padding: 4px 8px;
		border-radius: 4px;
		font-size: 12px;
		z-index: 10;
		animation: fadeOut 3s ease-in-out;
	}

	@keyframes fadeInOut {
		0% {
			opacity: 0;
		}

		20% {
			opacity: 1;
		}

		80% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	// 必填/必选字段的特殊样式
	.required-field {
		.el-switch {
			position: relative;

			&:after {
				content: '必填';
				position: absolute;
				top: -18px;
				left: 50%;
				transform: translateX(-50%);
				font-size: 10px;
				color: #f56c6c;
				background: #fff;
				padding: 2px 4px;
				border-radius: 2px;
				border: 1px solid #f56c6c;
				white-space: nowrap;
			}
		}
	}

	// 响应式适配
	@media (max-width: 992px) {
		.field-management-container {
			.field-add-dialog {
				width: 95% !important;

				.dialog-content {
					.dialog-columns {
						flex-direction: column;
						gap: 10px;

						.left-column,
						.middle-column,
						.right-column {
							min-height: auto;
						}
					}
				}
			}
		}
	}
</style>